exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-pill[data-v-407971ae] {\n  display: flex;\n  gap: 4px;\n  background-color: transparent;\n  border: 1px solid #085FCE;\n  padding: 4px 8px;\n  font-size: 14px;\n  margin: 0;\n  border-radius: 9999px;\n  color: #085FCE;\n}", ""]);

// exports
